import { render, staticRenderFns } from "./ConvenioLista.vue?vue&type=template&id=5140ce41&"
import script from "./ConvenioLista.vue?vue&type=script&lang=js&"
export * from "./ConvenioLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports